module.exports = {
  methods: {
    api() {
      let Events = window.Events;

      return {
        fetchSavedMessages() {
          return axios.get(`/api/saved_message`)
            .then(({data}) => data);
        },
        fetchContact(id) {
          return axios.get(`/api/contact/${id}`)
            .then(({data}) => data);
        },
        fetchModule(id) {
          return axios.get(`/api/module/${id}`)
            .then(({data}) => data);
        },
        fetchDocument(id) {
          return axios.get(`/api/document/${id}`)
            .then(({data}) => data);
        },
        fetchDocumentByLink(guid) {
          return axios.get(`/api/document-link/${guid}`)
            .then(({data}) => data);
        },
        fetchDocumentAnalytics(id) {
          return axios.get(`/api/document/${id}/analytics`)
            .then(({data}) => data);
        },
        fetchDocumentComments(id) {
          return axios.get(`/api/document/${id}/comment`)
            .then(({data}) => data);
        },
        fetchRecentComments() {
          return axios.get(`/api/comment/recent`)
            .then(({data}) => data);
        },
        fetchTeamActivities(page, filters) {
          page = page || 1;
          return axios.get(`/api/activity`, {
              params: Object.assign({ page: page }, filters)
            }).then(({data}) => data);
        },
        fetchTeamModules() {
          return axios.get(`/api/module`)
            .then(({data}) => data);
        },
        fetchArchivedTeamContacts() {
          return axios.get(`/api/contact/archived`)
            .then(({data}) => data);
        },
        fetchTeams() {
          return axios.get(`/api/teams`)
            .then(({data}) => data);
        },
        fetchTeamContacts() {
          return axios.get(`/api/contact`)
            .then(({data}) => data);
        },
        fetchTeamDocuments() {
          return axios.get(`/api/document`)
            .then(({data}) => data);
        },
        fetchTemplate(id) {
          return axios.get(`/api/template/${id}`)
            .then(({data}) => data);
        },
        fetchTeamTemplates: function() {
          return axios.get(`/api/template`)
            .then(({data}) => data);
        },
        fetchRecentDocuments: function() {
          return axios.get(`/api/document/recent`)
            .then(({data}) => data);
        },
        createSavedMessage(message) {
          return axios.post('/api/saved_message', message)
            .then(({data}) => data)
            .then(message => { Events.$emit('createSavedMessage', message); return message; });
        },
        createModule(options) {
          return axios.post('/api/module', options)
            .then(({data}) => data);
        },
        createDocument(document) {
          return axios.post('/api/document', document)
            .then(({data}) => data);
        },
        createTemplate() {
          return axios.post(`/api/template`, {
              title: 'New Template'
            }).then(({data}) => data);
        },
        createContact(contact) {
          return axios.post(`/api/contact`, contact)
            .then(({data}) => data)
            .then(contact => Events.$emit('createContact', contact));
        },
        createComment(id, comment) {
          return axios.post(`/api/document/${id}/comment`, comment)
            .then(({data}) => data)
            .then(comment => Events.$emit('createComment', comment));
        },
        createAnalytics(guid, analytics) {
          return axios.post(`/api/document-link/${guid}/analytic`, analytics)
            .then(({data}) => data);
        },
        updateDocument(id, payload) {
          return axios.post(`/api/document/${id}`, payload)
            .then(({data}) => data);
        },
        updateTemplate(id, payload) {
          return axios.post(`/api/template/${id}`, payload)
            .then(({data}) => data);
        },
        updateSavedMessage(message) {
          return axios.post(`/api/saved_message/${message.id}`, message)
            .then(({data}) => data)
            .then(message => { Events.$emit('updateSavedMessage', message); return message; });
        },
        updateModule(id, payload) {
          return axios.post(`/api/module/${id}`, payload)
            .then(({data}) => data);
        },
        updateContact(id, contact) {
          return axios.post(`/api/contact/${id}`, contact)
            .then(({data}) => data)
            .then(contact => Events.$emit('updateContact', contact));
        },
        archiveContact(id) {
          return axios.delete(`/api/contact/${id}`)
            .then(({data}) => data)
            .then(contact => Events.$emit('archiveContact', contact));
        },
        unarchiveContact(id) {
          return axios.post(`/api/contact/${id}/unarchive`)
            .then(({data}) => data);
        },
        deleteSavedMessage(id) {
          return axios.delete(`/api/saved_message/${id}`)
            .then(({status}) => status === 200)
            .then(status => { Events.$emit('deleteSavedMessage', status); return status; });
        },
        deleteDocument(id) {
          return axios.delete(`/api/document/${id}`)
            .then(({status}) => status === 200);
        },
        sendDocument(id, message) {
          return axios.post(`/api/document/${id}/send`, message)
            .then(({data}) => data);
        },
        sendTeamInvite(teamId, invite) {
          return axios.post(`/settings/teams/${teamId}/invitations`, invite)
            .then(({data}) => data);
        },
        watchDocument(document_id, user_id) {
          return axios.post(`/api/document/${document_id}/watcher/${user_id}`)
            .then(({data}) => data);
        },
        unwatchDocument(document_id, user_id) {
          return axios.delete(`/api/document/${document_id}/watcher/${user_id}`)
            .then(({status}) => status === 200);
        },
      }
    }
  }
};



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/api.js